import { render, staticRenderFns } from "./CuponExtraInfo.vue?vue&type=template&id=09415fdb&scoped=true&"
import script from "./CuponExtraInfo.vue?vue&type=script&lang=js&"
export * from "./CuponExtraInfo.vue?vue&type=script&lang=js&"
import style0 from "./CuponExtraInfo.vue?vue&type=style&index=0&id=09415fdb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09415fdb",
  null
  
)

export default component.exports